import { render } from "./add-Credintial.vue?vue&type=template&id=2be4b686&scoped=true"
import script from "./add-Credintial.vue?vue&type=script&lang=js"
export * from "./add-Credintial.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./add-Credintial.vue?vue&type=style&index=1&id=2be4b686&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be4b686"]])

export default __exports__